import { NgModule } from '@angular/core';

import {
  DxListModule,
  DxButtonModule,
  DxTagBoxModule,
  DxRangeSliderModule,
  DxTextBoxModule,
  DxDateBoxModule,
  DxCalendarModule,
  DxSliderModule,
  DxSwitchModule,
  DxDataGridModule,
  DxSortableModule,
  DxTabPanelModule,
  DxTemplateModule,
  DxTabsModule,
  DxSelectBoxModule,
  DxCheckBoxModule,
  DxLoadIndicatorModule,
  DxScrollViewModule,
  DxAccordionModule,
  DxTreeViewModule,
  DxTreeListModule,
  DxPopupModule,
  DxNumberBoxModule,
  DxTextAreaModule,
  DxDropDownButtonModule,
  DxTooltipModule,
  DxToolbarModule,
  DxDrawerModule,
  DxValidatorModule,
  DxPopoverModule,
  DxValidationGroupModule,
  DxRadioGroupModule,
  DxHtmlEditorModule,
  DxButtonGroupModule,
} from 'devextreme-angular';

@NgModule({
  exports: [
    DxListModule,
    DxButtonModule,
    DxRangeSliderModule,
    DxTagBoxModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxCalendarModule,
    DxSliderModule,
    DxSwitchModule,
    DxDataGridModule,
    DxSortableModule,
    DxTabPanelModule,
    DxTemplateModule,
    DxTabsModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxLoadIndicatorModule,
    DxTreeViewModule,
    DxTreeListModule,
    DxAccordionModule,
    DxScrollViewModule,
    DxPopupModule,
    DxNumberBoxModule,
    DxTextAreaModule,
    DxDropDownButtonModule,
    DxTooltipModule,
    DxToolbarModule,
    DxDrawerModule,
    DxValidatorModule,
    DxPopoverModule,
    DxValidationGroupModule,
    DxRadioGroupModule,
    DxHtmlEditorModule,
    DxButtonGroupModule,
  ],
  providers: [
  ],
})
export class DevExpressModule { }
